<template>
  <client-only>
    <logged-in-header prefix="field"></logged-in-header>
  </client-only>
  <main class="content">
    <slot />

    <client-only>
      <div>
        <Popup v-if="showEditBoardPopup" @close="closeEditPopup">
          <GalleryEditor v-if="currentBoard" :gallery="currentBoard" @updated="closeContact" @close="closeContact" />
          <GalleryEditor v-else @updated="closeContact" @close="closeContact" />
        </Popup>
      </div>

      <Popup v-if="showDeleteBoardPopup" @close="closeDeletePopup">
        <DeleteWorkForm :work="currentBoard" @close="closeDeletePopup" @deleteWork="deleteWorkCompleted" />
      </Popup>
    </client-only>
  </main>

  <client-only>
    <footer-basic></footer-basic>
  </client-only>
</template>

<script setup lang="ts">
import LoggedInHeader from '~/components/core/header/LoggedInHeader.vue';
import FooterBasic from '~/components/core/FooterBasic.vue';
import GalleryEditor from '~/components/boards/GalleryEditor.vue';
import Popup from '~/components/Popup.vue';
import DeleteWorkForm from '~/components/works/DeleteWorkForm.vue';
import { useWorkStore } from '~/composables/useWorkStore';
import { useUserStore } from '~/composables/useUserStore';

const { showLayout } = useUserStore();
// Use the state from useWorkStore composable
const {
  showEditBoardPopup,
  showDeleteBoardPopup,
  currentBoard,
  toggleEditBoardPopup,
  toggleDeleteBoardPopup,
  loadUserGalleries,
  deleteGallery
} = useWorkStore();

watch(showLayout, (newShowLayout) => {
  console.log('showLayout', newShowLayout);
});
// Popup close handlers
const closeEditPopup = async () => {
  console.log('close edit popup');
  toggleEditBoardPopup(null); // Close the edit popup
};

const closeDeletePopup = async () => {
  toggleDeleteBoardPopup(null); // Close the delete popup
  console.log('Delete popup closed');
};

// Delete gallery and reload data
const deleteWorkCompleted = async (data: any) => {
  console.log('Deleting work:', data);
  await deleteGallery(data.id); // Call delete function
  await loadUserGalleries(); // Reload galleries after deletion
  toggleDeleteBoardPopup(null); // Close the delete popup
};

const closeContact = async (data: any) => {
  console.log('close edit work', data);
  await closeEditPopup();
  if (data) {
    await loadUserGalleries(); // Reload galleries after deletion
  }
};
</script>
<style scoped>
.content {
  margin-top: 64px;
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .content {
    margin-top: 100px;
  }
}
</style>